"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spaceMemberManage = void 0;
const immer_1 = require("immer");
const actions = __importStar(require("../../../shared/store/action_constants"));
const defaultState = {
    // selected teams
    selectedTeamInfoInSpace: {
        teamTitle: '',
        teamId: '0',
    },
    // members list
    memberListInSpace: [],
    memberInfoInSpace: {
        memberId: '',
        email: '',
    },
    selectedRows: [],
    selectMemberListInSpace: [],
    rightClickTeamInfoInSpace: {
        teamTitle: '',
        teamId: '',
    },
    subTeamListInSpace: [],
    teamListInSpace: [],
    isInvited: false,
    selectedTeamKeys: [],
    selectedTeamRows: [],
};
exports.spaceMemberManage = (0, immer_1.produce)((storeData = defaultState, action) => {
    switch (action.type) {
        case actions.UPDATE_MEMBER_LIST_IN_SPACE: {
            storeData.memberListInSpace = action.payload;
            return storeData;
        }
        case actions.UPDATE_SELECTED_TEAM_INFO_IN_SPACE: {
            storeData.selectedTeamInfoInSpace = action.payload;
            return storeData;
        }
        case actions.UPDATE_RIGHT_CLICK_TEAM_INFO_IN_SPACE: {
            storeData.rightClickTeamInfoInSpace = action.payload;
            return storeData;
        }
        case actions.UPDATE_MEMBER_INFO_IN_SPACE: {
            storeData.memberInfoInSpace = action.payload;
            return storeData;
        }
        case actions.UPDATE_SELECT_MEMBER_LIST_IN_SPACE: {
            storeData.selectMemberListInSpace = action.payload;
            return storeData;
        }
        case actions.UPDATE_SELECTED_ROWS_IN_SPACE: {
            storeData.selectedRows = action.payload;
            return storeData;
        }
        case actions.UPDATE_SUB_TEAM_LIST_IN_SPACE: {
            storeData.subTeamListInSpace = action.payload;
            return storeData;
        }
        case actions.UPDATE_TEAM_LIST_IN_SPACE: {
            storeData.teamListInSpace = action.payload;
            return storeData;
        }
        case actions.UPDATE_INVITED_STATUS: {
            storeData.isInvited = action.payload;
            return storeData;
        }
        case actions.UPDATE_SELECTED_TEAM_KEYS: {
            storeData.selectedTeamKeys = action.payload;
            return storeData;
        }
        case actions.UPDATE_SELECTED_TEAM_ROWS: {
            storeData.selectedTeamRows = action.payload;
            return storeData;
        }
        default:
            return storeData;
    }
}, defaultState);
//# sourceMappingURL=space_member_manage.js.map